<template>
    <div class="blazon-container">
        <svg version="1.1" id="Vrstva_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 95 100" style="enable-background:new 0 0 95 100;" xml:space="preserve">
        <path id="Path_1476_2_" :style="{ fill: settings.primaryColor }" class="st0" d="M94.8,20.5C76.3,3.4,47.5,0,47.5,0S18.7,3.4,0.2,20.5c0,3.8-5.9,63.9,47.3,79.5
            C100.7,84.4,94.8,24.4,94.8,20.5z"/>
        <path id="Path_1477_2_" :style="{ fill: settings.secondaryColor }" class="st1" d="M47.5,0L47.5,0c0,0-28.8,3.4-47.3,20.5c0,3.8-5.9,63.9,47.3,79.5l0,0V0z"/>
        <path class="st2" :style="{ fill: settings.borderColor }" d="M47.5,10.1c4.9,0.8,23.7,4.4,37.5,15.2c0.4,20.6-4.6,53-37.5,64.2C14.6,78.2,9.6,45.9,10,25.3
            C23.8,14.5,42.6,10.9,47.5,10.1 M47.5,0c0,0-28.8,3.4-47.3,20.5c0,3.8-5.9,63.9,47.3,79.5c53.2-15.6,47.3-75.6,47.3-79.5
            C76.3,3.4,47.5,0,47.5,0L47.5,0L47.5,0z"/>
        </svg>
        <i :class="settings.icon" :style="{ color: settings.iconColor }"></i>
    </div>

</template>

<script>
    import Blazon from './Blazon';

    export default {
        name: 'Blazon1',
        mixins: [
            Blazon,
        ],
    }
</script>
